<!-- src/App.vue -->
<template>
  <div class="app">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <nouvelle-version />
  </div>
</template>

<script>
import NouvelleVersion from '@/components/common/NouvelleVersion.vue';

export default {
  name: 'App',
  components: { NouvelleVersion }
}
</script>

<style lang="scss">
@import '@/assets/css/main.css';
</style>
